export const dataUrlToBlob = (url: string): Blob => {
  const byteString = window.atob(url.split(",")[1]);
  const buffer = new Uint8Array(byteString.length);
  for (let index = 0; index < byteString.length; index++) buffer[index] = byteString.charCodeAt(index);
  return new Blob([buffer], { type: /data:(.*?)(;|,)/.exec(url)?.[1] });
};
